<template>
  <app-layout>
    <template #header>
      <div class="flex justify-between">
        <div class="flex flex-row space-x-6">

        </div>
        <div
          class="cursor-pointer"
          @click="openFilter = true"
        >
          <span> Filtro <i class="fa fa-filter"></i></span>
        </div>

        <jet-modal
          :show="openFilter"
          @close="openFilter = false"
          :closeable="true"
          max-width="6xl"
          class="overflow-auto h-32 "
        >
          <form @submit.prevent="filtrar">
            <div class="grid grid-cols-12 gap-6 py-8 px-12">
              <div class="col-span-12  ">
                <label class="block font-medium text-sm text-gray-700">
                  <span class="text-lg">
                    Período
                  </span>
                </label>
                <div class="flex md:space-x-4">
                  <el-date-picker
                    v-model="form.periodo_de"
                    format="dd/MM/yyyy"
                    value-format="yyyyMMdd"
                    type="date"
                  ></el-date-picker>
                  <div class="my-auto">
                    <span>a</span>
                  </div>
                  <el-date-picker
                    v-model="form.periodo_ate"
                    format="dd/MM/yyyy"
                    value-format="yyyyMMdd"
                    type="date"
                  ></el-date-picker>
                </div>

              </div>

            </div>

          </form>
        </jet-modal>
      </div>
    </template>
    <div class="py-6">
      <div class="max-w-8xl mx-auto px-1 sm:px-6 lg:px-4 space-y-2">
        <h1>Dashboard</h1>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import Welcome from '@/Jetstream/Welcome'
import JetModal from '@/Jetstream/Modal'
import Card from './Card';
import BarChart from './BarChart';
import BarStackedChart from './BarStackedChart';
import CheckGroup from '@/Components/CheckGroup';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import MenuItem from "./MenuItem.vue";
export default {
  name: 'DashboardIndex',
  components: {
    AppLayout,
    Welcome,
    Card,
    BarChart,
    JetModal,
    CheckGroup,
    ButtonPrimary,
    ButtonSecondary,
    BarStackedChart,
    MenuItem,
  },
  data() {
    return {
      openFilter: false,
      form: {
        centro_custos: _.get(this.filtros, 'centro_custos', []),
        periodo_de: _.get(this.filtros, 'periodo_de'),
        periodo_ate: _.get(this.filtros, 'periodo_ate'),
      }
    }
  }
}
</script>
